import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungRecklinghausen() {
  return (
    <CityPageTemplate
      city="Recklinghausen"
      slug="recklinghausen"
      intro="Recklinghausen als Tor zum Ruhrgebiet – wir bringen Deine Finanzen auf den richtigen Kurs."
      description="Unabhängige & digitale Finanzberatung für Recklinghausen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
